import { useContext, useEffect, useMemo, useState } from 'react';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import Dropdowns from '../../../../components/Dropdowns/Dropdowns';
import Input from '../../../../components/Inputs/Input';
import { DropdownsContext, useDropdownConfig } from '../../../../contexts/DropdownsContext';
import './GeneralInfo.css';
import { createPart } from '../../services/PartsConfigurationService';
import { HTTP_RESPONSE_CODES } from '../../../../globals/globals';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { useDispatch } from 'react-redux';
import { closeEditing, closeUnsaved, discardPart, setUnsave, startEditing } from '../../../../redux/features/configuration/parts/partsConfigurationSlice';
import Skeleton from 'react-loading-skeleton';
import { keepIf } from '@amcharts/amcharts5/.internal/core/util/Array';

const saveButtons = [
    { label: 'Save and Finish', icon: "icon-save", id: 'save' },
    { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
    { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
];

const hideFieldsOnSave = ["partNumber", "description", "category", "subCategory", "atachapter", "atasection", "ataparagraph"]

const requiredFields = ["partNumber", "categoryId", "subCategoryId", "description", "uomId", "manufacturerId"];

export const GeneralInfo = ({ part, updatePart, isUnderEdition, propagateChanges }) => {

    //part info used to change the dropdowns preSelectValue and preFill input values
    const [partInfo, setPartInfo] = useState(part);

    // aviationPart to change ata preselections;
    const [aviationPart, setAviationPart] = useState(part?.aviationPart);

    //values to edit & send to the backend;
    const [values, setValues] = useState(part);

    const { setDropdownsData } = useContext(DropdownsContext);

    const dispatch = useDispatch();


    //dropdowns data
    const atachapter = useDropdownConfig(8);
    const atasection = useDropdownConfig(9);
    const ataparagraph = useDropdownConfig(10);
    const category = useDropdownConfig(4);
    const subcategory = useDropdownConfig(5);
    const uom = useDropdownConfig(6);
    const manufacturer = useDropdownConfig(7);

    //snackbar
    const { successMsg, warningMsg, infoMsg } = useSnackBar();

    const loadedDropdowns = useMemo(() => {
        return atachapter && atasection && ataparagraph && category && subcategory && uom && manufacturer;
    }, [atachapter, atasection, ataparagraph, category, subcategory, uom, manufacturer]);

    useEffect(() => {
        // setPartInfo(part);
        // setValues(part);
        // setAviationPart(part?.aviationPart);
        setPartInfo(prev => (prev ? { ...part, ...(prev ?? {}) } : part));
        setValues(prev => (prev ? { ...part, ...(prev ?? {}) } : part));
        setAviationPart(prev => (prev?.aviationPart ? { ...(part?.aviationPart ?? {}), ...(prev?.aviationPart ?? {}) } : part?.aviationPart));
    }, [part]);


    const startEdition = () => {
        dispatch(startEditing({ section: "general", partId: part.id }))
    }

    const closeEdition = () => {
        dispatch(closeEditing({ section: "general", partId: part.id }))

    }

    const saveCall = (closeEditMode) => {
        infoMsg("Saving part");
        setFormTry(true);
        createPart(values).then(response => {
            if (response.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
                successMsg("Part Saved successfully");
                updatePart(response.data.load);
                setValues(response.data.load);
                if (closeEditMode) {
                    closeEdition("general");
                }
                dispatch(closeUnsaved({ section: "general", partId: part.id }));
                setUnsaveFlag(false);

            } else if (response.data.responseCode === HTTP_RESPONSE_CODES.VALIDATIONS_FAILED) {
                warningMsg(response.data.message, (response.data.validationErrors?.length > 0 ? `${response.data.validationErrors.map(e => e.error).join(', ')}` : '') || response.data.message || `${response.data.responseCode}`);

            } else {
                warningMsg(response.data.message);
            }

        }).catch(error => {
            //TODO: handle axios error
        })

    }

    const cancel = () => {
        if (partInfo.version === 0) {
            infoMsg("Unsaved Part Discarded");
            dispatch(discardPart(partInfo));
        } else {
            setPartInfo(part);
            setValues(part);
            setAviationPart(part?.aviationPart);
            dispatch(closeUnsaved({ section: "general", partId: part.id }));
            setUnsaveFlag(false);

        }
        closeEdition("general");

    }

    const [unsaveFlag, setUnsaveFlag] = useState(false);
    const [debUnsaveFlag, setDebUnsaveFlag] = useState(false);
    useEffect(() => {
        // propagateChanges(values);
        const handler = setTimeout(() => {
            setDebUnsaveFlag(unsaveFlag);
        }, 200); // 300ms debounce delay

        return () => {
            clearTimeout(handler); // Cleanup function to avoid memory leaks
        };
    }, [unsaveFlag]);

    useEffect(() => {
        if (part && debUnsaveFlag) dispatch(setUnsave({ section: "general", partId: part.id }));
    }, [debUnsaveFlag])


    const valueChange = (e) => {
        if (e) {
            let { name, value } = e;
            setValues(prev => ({ ...prev, [name]: value }));
            setUnsaveFlag(true);
        }
    }

    const handleTxtInput = (e) => {
        let { name, value } = e.target;
        valueChange({ name, value: value.toUpperCase() })
    }

    const [availableUom, setAvailableUom] = useState([]);


    const handleDropdown = (name, option) => {
        console.warn('*handling dropdown change', name, option);
        switch (name) {
            case "category":
                setPartInfo(prev => ({ ...prev, categoryId: option.id, categoryName: option.name, subCategoryName: "", subCategoryId: null, uomId: option.name === "Serialized" ? (availableUom.find(uM => uM.name === "Each")?.id ?? prev.uomId) : prev.uomId, }));
                setValues(prev => ({ ...prev, uomId: option.name === "Serialized" ? (availableUom.find(uM => uM.name === "Each")?.id ?? prev.uomId) : prev.uomId, subCategoryId: null, categoryId: option.id, categoryName: option.name, subCategoryName: "" }))
                break;
            case "subcategory":
                setValues(prev => ({ ...prev, subCategoryId: option.id, subCategoryName: option.name }));
                setPartInfo(prev => ({ ...prev, subCategoryId: option.id, subCategoryName: option.name }));
                break;
            case "uom":
                setValues(prev => ({ ...prev, uomId: option.id }));
                setPartInfo(prev => ({ ...prev, uomId: option.id }));
                break;
            case "manufacturer":
                setValues(prev => ({ ...prev, manufacturerId: option.id }));
                break;
            case "atachapter":
                setAviationPart(prev => ({ ...prev, atachapterId: option.id, atasectionId: null, ataparagraphId: null }));
                setValues(prev => ({
                    ...prev,
                    aviationPart: prev.aviationPart ?
                        { ...prev.aviationPart, atachapterName: option.chapter_number, atachapterId: option.id, atasectionId: null, atasectionName: "00", ataparagraphId: null, ataparagraphName: "00" } :
                        { id: null, companyId: prev.companyId || part.companyId || localStorage.getItem("u_company_id"), atachapterId: option.id, atachapterName: option.chapter_number }
                }));
                break;
            case "atasection":
                setAviationPart(prev => ({ ...prev, atasectionId: option.id, ataparagraphId: null, atasectionName: option.section_number, ataparagraphName: "00" }));
                setValues(prev => ({
                    ...prev, aviationPart: prev.aviationPart ?
                        { ...prev.aviationPart, atasectionId: option.id, ataparagraphId: null, atasectionName: option.section_number, ataparagraphName: "00" } :
                        { id: null, companyId: prev.companyId || part.companyId || localStorage.getItem("u_company_id"), atasectionId: option.id, atasectionName: option.section_number }
                }));
                break;
            case "ataparagraph":
                setAviationPart(prev => ({ ...prev, ataparagraphId: option.id, ataparagraphName: option.paragraph_number }));
                setValues(prev => ({ ...prev, aviationPart: prev.aviationPart ? { ...prev.aviationPart, ataparagraphId: option.id, ataparagraphName: option.paragraph_number } : { id: null, companyId: prev.companyId || part.companyId || localStorage.getItem("u_company_id"), ataparagraphId: option.id, ataparagraphName: option.paragraph_number } }));
                break;
        }
        setUnsaveFlag(true);

    }
    const handleDropdownClear = (name) => {
        switch (name) {
            case "category":
                setPartInfo(prev => ({ ...prev, categoryName: "", subCategoryName: "", subCategoryId: null }));
                setValues(prev => ({ ...prev, subCategoryId: null, categoryId: null, categoryName: "", subCategoryName: "" }))
                break;
            case "subcategory":
                setValues(prev => ({ ...prev, subCategoryId: null, subCategoryName: "" }));
                break;
            case "uom":
                setValues(prev => ({ ...prev, uomId: null }));
                break;
            case "manufacturer":
                setValues(prev => ({ ...prev, manufacturerId: null }));
                break;
            case "atachapter":
                setAviationPart({ atasectionId: null, ataparagraphId: null });
                setValues(prev => ({ ...prev, aviationPart: null }));
                // setAviationPart(prev => ({ ...prev, atachapterId: null, atasectionId: null, ataparagraphId: null }));
                // setValues(prev => ({
                //     ...prev,
                //     aviationPart: prev.aviationPart ?
                //         { ...prev.aviationPart, atachapterName: "00", atachapterId:null, atasectionId: null, atasectionName: "00", ataparagraphId: null, ataparagraphName: "00" } :
                //         { id: null, companyId: prev.companyId, atachapterId: option.id, atachapterName: option.chapter_number }
                // }));
                break;
            case "atasection":
                // setAviationPart(prev => ({ ...prev, atasectionId: option.id, ataparagraphId: null, atasectionName: option.section_number, ataparagraphName: "00" }));
                // setValues(prev => ({
                //     ...prev, aviationPart: prev.aviationPart ?
                //         { ...prev.aviationPart, atasectionId: option.id, ataparagraphId: null, atasectionName: option.section_number, ataparagraphName: "00" } :
                //         { id: null, companyId: prev.companyId, atasectionId: option.id, atasectionName: option.section_number }
                // }));
                break;
            case "ataparagraph":
                // setAviationPart(prev => ({ ...prev, ataparagraphId: option.id, ataparagraphName: option.paragraph_number }));
                // setValues(prev => ({ ...prev, aviationPart: prev.aviationPart ? { ...prev.aviationPart, ataparagraphId: option.id, ataparagraphName: option.paragraph_number } : { id: null, companyId: prev.companyId, ataparagraphId: option.id, ataparagraphName: option.paragraph_number } }));
                break;
        }
        setUnsaveFlag(true);

    }

    const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
        setDropdownsData((prevDropdowns) =>
            prevDropdowns.map((filter) => {
                if (filter.id === dropdownId) {
                    return {
                        ...filter,
                        parentValues,
                        dependenciesToUpdate,
                        reload: true,
                    };
                }
                return filter;
            })
        );
    };

    const resetDropdownsReload = () => {
        setDropdownsData((filterState) => {
            if (filterState.length > 0) {
                return filterState.map((e) => {
                    if (e.reload) {
                        return { ...e, reload: false };
                    }
                    return e;
                });
            }
            return filterState;
        });
    };

    const [debouncedValues, setDebouncedValues] = useState(values);


    useEffect(() => {
        if (debouncedValues) {
            propagateChanges(debouncedValues);
            // dispatch(setUnsave({section: "general", partId: part.id}));
        }
    }, [debouncedValues])

    useEffect(() => {
        // propagateChanges(values);

        const handler = setTimeout(() => {
            setDebouncedValues(values);
        }, 300); // 300ms debounce delay

        return () => {
            clearTimeout(handler); // Cleanup function to avoid memory leaks
        };
    }, [values]);


    //Form validation
    const [formTry, setFormTry] = useState(false);
    const [errorStatus, setErrorStatus] = useState({});

    useEffect(() => {
        if (formTry) {
            setErrorStatus(
                Object.fromEntries(requiredFields.filter(name => !((typeof (debouncedValues[name]) === 'string') || (typeof (debouncedValues[name]) === 'number'))).map(name => [name, "Required."]))
            )
        }
    }, [formTry, debouncedValues]);




    return (
        loadedDropdowns && <div className="general-info-component" style={{ position: 'relative' }}>
            {/* {Object.entries(partInfo ?? {}).map(([key, value]) => ["categoryId", "subCategoryId"].includes(key) && <div>
                <b>{key}:</b> <span>{JSON.stringify(value)}</span>
             </div>)} */}
            <div style={{ position: 'absolute', top: '0', left: '0', background: "#FF00FF50", zIndex: 2, fontSize: '0.3rem' }}>
                {/* {JSON.stringify(partInfo)} */}
            </div>
            <div className='header'>
                <div className='title'>
                    <b>General Information</b>
                    {!isUnderEdition && <button onClick={() => startEdition("general")} className='outlined iconTextButton small-size'>
                        <i className='icon-edit'></i>
                        <span>Edit</span>
                    </button>}
                </div>
                {isUnderEdition && <MultioptionButton buttonCallbacks={{
                    'save': () => saveCall(true),
                    'save-continue': () => saveCall(false),
                    'cancel': () => cancel()
                }} buttons={saveButtons}></MultioptionButton>}
            </div>
            {/* TODO: show skeleton when partInfo is not defined or null */}
            {partInfo && <div className='form'>
                {isUnderEdition && <Input disableAutocomplete value={values.partNumber} error={errorStatus["partNumber"]} required onChange={handleTxtInput} disabled={!isUnderEdition} name="partNumber" upperCase preFillValue={partInfo?.partNumber} label="PN" style={{ gridColumn: "span 3" }} />}
                <div className='ata' style={{ gridColumn: "span 3", display: isUnderEdition ? 'grid' : "none" }}>
                    <b>ATA</b>
                    <Dropdowns orderFn={(a, b) => Number(a.chapter_number) - Number(b.chapter_number)} handleClear={() => handleDropdownClear("atachapter")} selectionLabel="chapter_number" optionLabel="description" updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={(e) => handleDropdown("atachapter", e)} disabled={!isUnderEdition} preSelectValue={aviationPart?.atachapterId} data={atachapter.config} fixedLabel />
                    <Dropdowns orderFn={(a, b) => Number(a.section_number) - Number(b.section_number)} hideRequiredLabel required={values.aviationPart?.atachapterId} selectionLabel="section_number" optionLabel="description" updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={(e) => handleDropdown("atasection", e)} disabled={!isUnderEdition} preSelectValue={aviationPart?.atasectionId} data={atasection.config} fixedLabel />
                    <Dropdowns orderFn={(a, b) => Number(a.paragraph_number) - Number(b.paragraph_number)} hideRequiredLabel required={values.aviationPart?.atachapterId} selectionLabel="paragraph_number" optionLabel="description" updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={(e) => handleDropdown("ataparagraph", e)} disabled={!isUnderEdition} preSelectValue={aviationPart?.ataparagraphId} data={ataparagraph.config} fixedLabel />
                    {/* <Input label="Chapter" /> */}
                    {/* <Input label="Section" />
                    <Input label="Paragraph" /> */}
                </div>
                {isUnderEdition && <Input disableAutocomplete value={values.description} error={errorStatus["description"]} required upperCase onChange={handleTxtInput} disabled={!isUnderEdition} name="description" preFillValue={partInfo.description} label="Description" style={{ gridColumn: "span 6" }} />}
                {/* <Input value={values.name} error={errorStatus["name"]} required upperCase onChange={handleTxtInput} disabled={!isUnderEdition} name="name" preFillValue={partInfo.name} label="Name" style={{ gridColumn: "span 6" }} /> */}
                {isUnderEdition && <>
                    <div className={`categorySupperContainer ${values.subCategoryName === "Tools and Equipment" ? "active" : ""}`}>

                        <div className='categoryContainer'>
                            <Dropdowns handleClear={() => handleDropdownClear("category")} activateErrorHint={Boolean(errorStatus.categoryId)} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={(e) => handleDropdown("category", e)} disabled={!isUnderEdition} preSelectValue={partInfo.categoryId} required data={category.config} />
                            <Dropdowns activateErrorHint={Boolean(errorStatus.subCategoryId)} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={(e) => handleDropdown("subcategory", e)} disabled={!isUnderEdition} preSelectValue={partInfo.subCategoryId} required data={subcategory.config} />

                        </div>
                        {/* <div style={{ gridColumn: "span 3" }} >
                    </div> */}
                        <div className={`toollifecontainer ${values.subCategoryName === "Tools and Equipment" ? "active" : ""}`}>
                            <Input name="toolLife" label="Tool Life" isNumeric value={values.toolLife} onChange={handleTxtInput} />
                            <b style={{ fontSize: "0.6rem" }}>Days</b>
                        </div>

                    </div>
                    {values.subCategoryName === "Tools and Equipment" && <></>}

                </>}

                <div style={{ gridColumn: "span 3" }} >
                    {/* {JSON.stringify(partInfo.uomId)} */}
                    <Dropdowns onOptionsChange={setAvailableUom} activateErrorHint={Boolean(errorStatus.uomId)} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={(e) => handleDropdown("uom", e)} disabled={!isUnderEdition || partInfo.categoryName === "Serialized"} preSelectValue={partInfo.uomId} required data={uom.config} />
                </div>
                <div style={{ gridColumn: "span 3" }} >
                    <Dropdowns activateErrorHint={Boolean(errorStatus.manufacturerId)} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} onOptionSelect={(e) => handleDropdown("manufacturer", e)} disabled={!isUnderEdition} preSelectValue={partInfo.manufacturerId} required data={manufacturer.config} />
                </div>

                {/* // TODO: handle checkboxes changes; */}
                <div className='checkboxes-container'>
                    <div className='checkbox-container'>
                        <CheckboxField onChange={(e) => valueChange({ name: "pmaStatus", value: e })} disabled={!isUnderEdition} checked={values.pmaStatus === true}> PMA </CheckboxField>
                    </div>
                    <div className='checkbox-container'>
                        <CheckboxField onChange={(e) => valueChange({ name: "hazardousMaterial", value: e })} disabled={!isUnderEdition} checked={values.hazardousMaterial === true}> <div className='icon-checkbox'>
                            <span>
                                Hazardous Material
                            </span>
                            <span class="icon-coloredwarning"><span class="path1"></span><span class="path2"></span></span>
                        </div></CheckboxField>
                    </div>

                    <div className='checkbox-container'>
                        <CheckboxField onChange={(e) => valueChange({ name: "receivingInspection", value: e })} disabled={!isUnderEdition} checked={values.receivingInspection === true}> Requires Inspection </CheckboxField>
                    </div>
                    <div className='checkbox-container'>
                        <CheckboxField onChange={(e) => valueChange({ name: "autoassignSerialNumber", value: e })} disabled={!isUnderEdition} checked={values.autoassignSerialNumber === true}> Autoassign SN</CheckboxField>
                    </div>
                </div>

            </div>}
            {
                !partInfo && <>
                    <Skeleton width="100%" height="2rem" />
                    <Skeleton width="100%" height="2rem" />
                    <Skeleton width="100%" height="2rem" />
                </>
            }

        </div>
    )
}
